import styled, { css } from 'styled-components'

import { helpers, responsiveQuery } from 'styles'

export const Card = styled.div`
	background-color: ${helpers.color.background};
	box-shadow: rgba(34, 34, 34, 0.08) 0px 1px 2px, rgba(0, 0, 0, 0.04) 0px -1px 4px;
	margin: 0 auto 1em;
	padding: 32px;

	${responsiveQuery.wide(css`
		max-width: ${(2 / 3) * 100}%;
	`)}
`
